import { expandRadius } from "@client/lib/settings";
import {
  combinedStyleSelector,
  createShallowEqualSelector,
  getColorSelector,
  getSettingValueSelector,
  TargetSelector
} from "@client/selectors";
import React from "react";
import { createSelector } from "reselect";

export const makeCourseImageStyleSelector = () => {
  const courseBorderRadiusSelector = getSettingValueSelector(TargetSelector.Entity, "radius", "course.border");

  return createShallowEqualSelector([courseBorderRadiusSelector], (br): React.CSSProperties => {
    const corners = expandRadius(br);
    return {
      borderTopLeftRadius: corners?.topLeft,
      borderTopRightRadius: corners?.topRight
    };
  });
};

export const makeCourseStyleSelector = () => {
  const styleSelector = combinedStyleSelector(TargetSelector.Entity, ["border", "boxShadow"], "course");
  const backgroundColorSelector = getColorSelector(TargetSelector.Entity, "backgroundColor", "course");

  return createSelector(
    [backgroundColorSelector, styleSelector],
    (backgroundColor, style): React.CSSProperties => ({
      backgroundColor,
      ...style
    })
  );
};
